import React from 'react'

const BannerLanding = (props) => (
    <section id="banner">
        <div className="inner">
            <header className="major">
                <h1>My Work</h1>
            </header>
            <div className="content">
                <p></p>
            </div>
        </div>
    </section>
)

export default BannerLanding
